import { Component } from "@theme/component";
import { decodeObfuscatedUrl } from "@theme/utilities";

/**
 * Navigates to the URL carried by any obfuscated List Pad control — a shortcut chip or a CTA.
 *
 * Those controls are deliberately `<button data-o>` (base64 URL) and not `<a href>`:
 * `.docs/seo-guidelines.md` [P1] forbids crawlable filter links, and the choice is made on the URL rather than on the style
 * the merchant picked. Progressive enhancement is therefore impossible here, which is why the pad
 * always carries its message through its title and its text too.
 *
 * Wraps both groups of a `content` pad, so a click anywhere inside resolves to the nearest
 * `[data-o]` ancestor.
 *
 * @extends Component<{}>
 */
class ListPadChips extends Component {
  /** @param {Event} event */
  navigate = (event) => {
    const { target } = event;
    if (!(target instanceof Element)) return;

    // The dispatcher retargets the event to the element holding `on:click`, but the click can
    // still land on the label span — walk up to the chip that carries the URL.
    const url = decodeObfuscatedUrl(target.closest("[data-o]")?.getAttribute("data-o") ?? undefined);

    if (url) window.location.assign(url);
  };
}

if (!customElements.get("list-pad-chips")) {
  customElements.define("list-pad-chips", ListPadChips);
}
